'use client';

import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';

import { IconBellOff } from 'src/general/Icons/IconBellOff';
import { IconBellOn } from 'src/general/Icons/IconBellOn';

import { Shade } from 'src/general/components/Shade/Shade';
import styles from './SearchAlertToggle.module.scss';

type SearchAlertToggleProps = {
  isActive: boolean;
  initialised?: boolean;
  disabled?: boolean;
  onHandleSwitch: (isActive: boolean) => Promise<void>;
};

export const SearchAlertToggle: FC<SearchAlertToggleProps> = ({
  isActive,
  disabled,
  initialised = true,
  onHandleSwitch,
}) => {
  const [mounted, setMounted] = useState<boolean>(false);
  const label = isActive ? 'Alert active' : 'Search alert';

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return false;
  }

  return (
    <label
      className={classNames(styles.switchWrapper, 'shade_container', {
        [styles.active]: isActive,
        [styles.disabled]: disabled,
        [styles.initialised]: initialised,
      })}
    >
      <Shade />
      <input
        type="checkbox"
        name="searchAlert"
        checked={isActive}
        onChange={() => onHandleSwitch(!isActive)}
        disabled={disabled}
        className={styles.checkbox}
      />
      <div className={styles.switch}>
        <IconBellOff className={classNames(styles.switchThumb, styles.iconOff)} />
        <IconBellOn className={classNames(styles.switchThumb, styles.iconOn)} />
      </div>
      <span className={classNames(styles.content, 'c-fs-caption', 'c-fw-bold')}>{label}</span>
    </label>
  );
};
